import React from 'react'
import { Segment, Accordion } from 'semantic-ui-react'
import { QuestionsListItem } from './QuestionsListItem'
import { hotkeys } from 'react-keyboard-shortcuts'
import Sortable from 'react-sortablejs';

class QuestionsList extends React.Component {

    hot_keys = {
        'ctrl+alt+1': {
            priority: 1,
            handler: (e) => { e.preventDefault(); this.handleActiveItemChange(true, 0) }
        },
        'ctrl+alt+2': {
            priority: 1,
            handler: (e) => { e.preventDefault(); this.handleActiveItemChange(true, 1) }
        },
        'ctrl+alt+3': {
            priority: 1,
            handler: (e) => { e.preventDefault(); this.handleActiveItemChange(true, 2) }
        },
        'ctrl+alt+4': {
            priority: 1,
            handler: (e) => { e.preventDefault(); this.handleActiveItemChange(true, 3) }
        },
        'ctrl+alt+5': {
            priority: 1,
            handler: (e) => { e.preventDefault(); this.handleActiveItemChange(true, 4) }
        },
        'ctrl+alt+6': {
            priority: 1,
            handler: (e) => { e.preventDefault(); this.handleActiveItemChange(true, 5) }
        },
        'ctrl+alt+7': {
            priority: 1,
            handler: (e) => { e.preventDefault(); this.handleActiveItemChange(true, 6) }
        },
        'ctrl+alt+8': {
            priority: 1,
            handler: (e) => { e.preventDefault(); this.handleActiveItemChange(true, 7) }
        },
        'ctrl+alt+9': {
            priority: 1,
            handler: (e) => { e.preventDefault(); this.handleActiveItemChange(true, 8) }
        },
    }

    state = { activeIndex: -1 }
    

    componentDidMount() {
        if (this.props.onMount)
            this.props.onMount()
    }

    handleActiveItemChange = (active, i) => this.setState({ activeIndex: (active ? i : -1) })


    handleMoveQuestion = (order) => {
        this.props.onMoveQuestion(order)
     }

    renderQuestionItem = (question, i) => {
        const { activeIndex } = this.state
        const { actions, actionsCallbacks, game_id } = this.props
        // ho aggiunto data-id per permettere il sorting
        return  <div data-id={question.id}>
            <QuestionsListItem key={question.id}
            game_id = {game_id}
            data-id = {question.id}
            index={i} 
            question_id={question.id} 
            actions={actions} 
            actionsCallbacks={actionsCallbacks}
            active={i === activeIndex}
            onActiveChange={(active) => this.handleActiveItemChange(active, i)} />
            </div>
    }



    render() {
        const { provider } = this.props
        const {disableOrder} = this.props
        const { questions, loading } = provider || { questions: this.props.question_game.map(q=>q.question), loading: false }
        return (
            <Accordion styled fluid style={{ marginTop: '1em', marginBottom: '1em' }}>
                {loading ? <Segment inverted loading style={{ height: '200px' }}></Segment> : ''}
                <Sortable  options= { {disabled : disableOrder}} onChange = {(order) => this.handleMoveQuestion(order)} > 
                {questions.length ? questions.map(this.renderQuestionItem) : <Segment content={<i>Nessuna domanda</i>} />}
                </Sortable> 
            </Accordion>

        )
    }
}

export default hotkeys(QuestionsList)


// WEBPACK FOOTER //
// ./src/components/QuestionsList.js